import { getOrderStatisticsPrimaryPhase, ORDER_PRIMARY_PHASE_META } from './orderPrimaryPhaseConfig';
import { accumulatePrimaryPhaseOrderFinancials, createEmptyPrimaryPhaseTotals } from './primaryPhaseOrderFinancials';
import { buildStatisticsMaterialScopedOrder } from '../../../filters/lib/statisticsMaterialLineContribution';

/** 从订单列表重算 overview / phases（V1 固定 operational；物料筛选按匹配行） */
export const aggregatePrimaryPhaseLensFromOrders = (orders, filters = {}) => {
	const phaseBuckets = Object.fromEntries(ORDER_PRIMARY_PHASE_META.map(({ phase }) => [phase, createEmptyPrimaryPhaseTotals()]));
	const overview = createEmptyPrimaryPhaseTotals();

	for (const order of orders) {
		const phase = getOrderStatisticsPrimaryPhase(order);
		if (!phase || !phaseBuckets[phase]) continue;
		const statsOrder = buildStatisticsMaterialScopedOrder(order, filters);
		accumulatePrimaryPhaseOrderFinancials(phaseBuckets[phase], statsOrder);
		accumulatePrimaryPhaseOrderFinancials(overview, statsOrder);
	}

	return {
		overview,
		phases: ORDER_PRIMARY_PHASE_META.map(({ phase }) => ({
			phase,
			...phaseBuckets[phase],
		})),
	};
};
